import { Component, input, model, ViewEncapsulation } from '@angular/core';
import { NODE_PARAMS_MAP, NodeType } from '@src/app/models/flow';

@Component({
    selector: 'app-flow-node-header',
    templateUrl: './flow-node-header.component.html',
    styleUrl: './flow-node-header.component.scss',
    standalone: false,
})
export class FlowNodeHeaderComponent {
    protected readonly defaultParams = NODE_PARAMS_MAP;

    public readonly expanded = model(false);
    public readonly description = input.required<string | undefined>();
    public readonly type = input.required<NodeType>();

    protected toggle(): void {
        this.expanded.update(x => !x);
    }
}
